import $ from "jquery";
import Cookies from "js-cookie";

// If the values of those keys are changed the also have to be changed in the Goolge Tag Manager
const cookieConsentKey = "cookie_consent";
const acceptedKey = "accepted";
const declinedKey = "declined";

function acceptMatomoAnalyticsCookies(): void {
  if (window._paq == undefined) {
    window._paq = [];
  }
  window._paq.push(["setCookieConsentGiven"]);
}

$(() => {
  const consentModal = $("#cookieConsentModal");

  const cookieConsentValue = Cookies.get(cookieConsentKey);
  if (cookieConsentValue == undefined) {
    consentModal.on("shown.bs.modal", () => {
      consentModal.trigger("focus");
    });
    consentModal.modal({
      backdrop: "static",
      keyboard: false,
      show: true,
    });

    $("#acceptCookies").on("click", () => {
      Cookies.set(cookieConsentKey, acceptedKey, { sameSite: "none", expires: 90, secure: true });
      acceptMatomoAnalyticsCookies();
    });

    $("#declineCookies").on("click", () => {
      Cookies.set(cookieConsentKey, declinedKey, { sameSite: "none", expires: 90, secure: true });
    });
  } else {
    consentModal.remove();
  }
  if (cookieConsentValue === acceptedKey) {
    acceptMatomoAnalyticsCookies();
  }
});
